export default __webpack_public_path__ + "static/pexels-mart-production-8458861_-3494e5c25dbe573f756d5644fcedb81c.jpg";